import { render, staticRenderFns } from "./UiTab.vue?vue&type=template&id=5d89645e&scoped=true"
import script from "./UiTab.vue?vue&type=script&lang=js"
export * from "./UiTab.vue?vue&type=script&lang=js"
import style0 from "./UiTab.vue?vue&type=style&index=0&id=5d89645e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89645e",
  null
  
)

export default component.exports